(() => {

  const players = [...document.querySelectorAll('[data-drg-player]')];
  if(!players.length) return;

  const TAP_THRESHOLD = 4;
  const SEEK_THRESHOLD = 4;
  const SEEK_DOMINANCE = 0.65;
  const TAP_CANCEL_THRESHOLD = 10;
  const DOUBLE_CLICK_MS = 260;

  const BARS = 500;
  const WAVE_GAIN = 0.55;

  const fmt = (sec) => {
    if(!Number.isFinite(sec) || sec < 0) return "--:--";
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return `${m}:${String(s).padStart(2,"0")}`;
  };

  const setupCanvas = (c) => {

    const dpr = window.devicePixelRatio || 1;

    const w = c.clientWidth || 1;
    const h = c.clientHeight || 1;

    c.width = Math.floor(w * dpr);
    c.height = Math.floor(h * dpr);

    const g = c.getContext("2d");

    g.setTransform(dpr,0,0,dpr,0,0);

    return g;
  };

  const extract = (ab) => {

    const ch = ab.getChannelData(0);

    const len = ch.length;

    const step = Math.floor(len / BARS) || 1;

    const peaks = new Uint8Array(BARS);

    for(let i=0;i<BARS;i++){

      let max = 0;

      const s = i * step;
      const e = Math.min((i + 1) * step, len);

      for(let j=s;j<e;j++){
        max = Math.max(max, Math.abs(ch[j]));
      }

      peaks[i] = Math.min(
        255,
        Math.round(max * 255)
      );
    }

    return peaks;
  };

  players.forEach(root => {

    const tracks = [
      ...root.querySelectorAll('.drg-track')
    ];

    if(!tracks.length) return;

    const buildGroupsByCode = () => {

  const groups = [];
  const map = new Map();

  tracks.forEach(t => {

    const groupCode =
      (t.dataset.code || "").trim();

    if(!groupCode){

      groups.push({
        parent: t,
        children: []
      });

      return;
    }

    if(!map.has(groupCode)){

      const group = {
        parent: t,
        children: []
      };

      map.set(groupCode, group);
      groups.push(group);

      return;
    }

    const group = map.get(groupCode);

    t.classList.add("drg-hide-child");

    group.children.push(t);

  });

  groups.forEach(group => {

    if(group.children.length){
      group.parent.dataset.drgGroupParent = "1";
    }

  });

  return groups;
};

const trackGroups =
  buildGroupsByCode();


    const audio = new Audio();

    audio.preload = "metadata";

    const peaksMem = new Map();

const peaksLoading = new Map();

let currentTrack = null;
    let timer = null;
    let visualTrack = null;

    let dragging = false;
    let dragTrack = null;

    let wasPlayingBeforeDrag = false;

    let startX = 0;
    let startY = 0;

    let movedX = 0;
    let movedY = 0;

    let clickTimer = null;

    let lastClickTrack = null;
    let lastClickTime = 0;

    const stopProgress = () => {

      if(timer){

        clearInterval(timer);

        timer = null;
      }
    };

    const closeGroups = () => {
  trackGroups.forEach(g => {
    g.parent.classList.remove("drg-group-open");

    const old = g.parent.querySelector(".drg-subclips");
    if(old) old.remove();
  });
};

const findGroupByParent = (t) => {
  return trackGroups.find(g => g.parent === t);
};

const findGroupByChild = (t) => {
  return trackGroups.find(g => g.children.includes(t));
};

const openGroup = (group) => {
  if(!group || !group.children.length) return;

  closeGroups();

  group.parent.classList.add("drg-group-open");

  const box = document.createElement("div");
  box.className = "drg-subclips";

  const parentTitle =
  (group.parent.dataset.playerTitle || group.parent.dataset.title || "").trim();

const allClips = [
  group.parent,
  ...group.children
];

allClips.forEach((clip, index) => {
  const item = document.createElement("div");
  item.className = "drg-subclip";

  const clipTitle =
    (clip.dataset.playerTitle || clip.dataset.title || "").trim();

  item.textContent =
    !clipTitle || clipTitle === parentTitle
      ? `Sample ${index + 1}`
      : clipTitle;

  item.addEventListener("pointerdown", e => {
    e.stopPropagation();
  });

  item.addEventListener("pointerup", e => {

  e.stopPropagation();
  e.preventDefault();

  if(!clip.classList.contains('drg-ready')){
    return;
  }

  playTrack(clip, 0);

  applyPlayingState(group.parent);

});

  box.appendChild(item);
});

  const metaLeft =
  group.parent.querySelector(".drg-meta-left");

if(metaLeft){
  metaLeft.appendChild(box);
}else{
  group.parent.appendChild(box);
}

const activeClip =
  currentTrack &&
  getVisualTrack(currentTrack) === group.parent
    ? currentTrack
    : group.parent;

setActiveClip(group.parent, activeClip);
};

    const clearStates = () => {

      tracks.forEach(t => {

        t.classList.remove(
          'drg-selected',
          'drg-playing',
          'drg-is-playing',
          'drg-is-hold',
          'drg-loading'
        );
      });
    };

    const applyPausedState = (t) => {

      if(!t) return;

      t.classList.remove(
        'drg-playing',
        'drg-is-playing',
        'drg-loading'
      );

      t.classList.add(
        'drg-selected',
        'drg-is-hold'
      );
    };

    const applyPlayingState = (t) => {

      if(!t) return;

      t.classList.remove(
        'drg-is-hold',
        'drg-loading'
      );

      t.classList.add(
        'drg-selected',
        'drg-playing',
        'drg-is-playing'
      );
    };

    const applyLoadingState = (t) => {

      if(!t) return;

      t.classList.add(
        'drg-selected',
        'drg-loading'
      );
    };

    const markMissing = (t) => {

      t.classList.add('drg-missing');

      t.classList.remove(
        'drg-selected',
        'drg-playing',
        'drg-is-playing',
        'drg-is-hold',
        'drg-loading'
      );

      const time =
        t.querySelector('[data-time]');

      if(time){
        time.textContent =
          '--:-- | --:--';
      }
    };

    const isMissing = (t) => {
      return t.classList.contains('drg-missing');
    };

    const setTime = (t, cur, total) => {

      const el =
        t.querySelector('[data-time]');

      if(el){

        el.textContent =
          `${fmt(cur)} | ${fmt(total)}`;
      }
    };

    const getVisualTrack = (t) => {
  const group = findGroupByChild(t);
  return group ? group.parent : t;
};

const setCopyType = (visual, source) => {

  const el =
    visual?.querySelector(".drg-copy");

  if(!el) return;

  const copy =
    source.querySelector(".drg-copy");

  if(!copy) return;

  el.textContent =
    copy.dataset.copy ||
    copy.textContent;
};

const setActiveClip = (visual, source) => {

  const group =
    findGroupByParent(visual);

  if(!group) return;

  const items =
    visual.querySelectorAll(".drg-subclip");

  items.forEach(item => {
    item.classList.remove("drg-subclip-active");
  });

  const index =
  source === visual
    ? 0
    : group.children.indexOf(source) + 1;

if(items[index]){
  items[index].classList.add("drg-subclip-active");
}
};

const setClipPos = (visual, current, total) => {
  const el = visual?.querySelector(".drg-clip-pos");
  if(!el) return;

  el.textContent =
    total > 1 ? `${current}/${total}` : "";
};

    const ratioAt = (t, x) => {

      const r =
        t.getBoundingClientRect();

      return Math.max(
        0,
        Math.min(
          1,
          (x - r.left) / r.width
        )
      );
    };

    /* =========================
       MARQUEE
    ========================= */

    const refreshMarquee = (t) => {

      const title =
        t.querySelector('.drg-player-title');

          if(
  t.classList.contains('drg-is-playing') ||
  t.classList.contains('drg-is-hold')
){
  return;
}

      const text =
        t.querySelector('.drg-player-title-text');

      if(!title || !text) return;

      title.classList.remove(
        'drg-can-marquee'
      );

      title.style.removeProperty(
        '--marquee-distance'
      );

      title.style.removeProperty(
        '--marquee-duration'
      );

      requestAnimationFrame(() => {

        const overflow =
          text.scrollWidth -
          title.clientWidth;

        if(overflow > 6){

          title.classList.add(
            'drg-can-marquee'
          );

          const distance =
            overflow + 32;

          title.style.setProperty(
            '--marquee-distance',
            `${distance}px`
          );

          const pxPerSec = 22;

          let dur =
            distance / pxPerSec;

          dur = Math.max(
            6,
            Math.min(18, dur)
          );

          title.style.setProperty(
            '--marquee-duration',
            `${dur}s`
          );
        }
      });
    };

    /* =========================
       WAVE
    ========================= */

    const drawWave = (t, ratio, sourceTrack = t) => {

      if(isMissing(t)) return;

      const c =
        t.querySelector('.drg-wave');

      const peaks =
  peaksMem.get(sourceTrack.dataset.src);

      if(!c || !peaks) return;

      const g = setupCanvas(c);

      const w = c.clientWidth;
      const h = c.clientHeight;

      g.clearRect(0,0,w,h);

      const cut = w * ratio;

      const step = w / peaks.length;

      const bw =
        Math.max(1, step * 0.7);

      const mid = h / 2;

      const base =
        getComputedStyle(root)
          .getPropertyValue('--wave-base')
          .trim() ||
          'rgba(0,0,0,0.12)';

      const play =
        getComputedStyle(root)
          .getPropertyValue('--wave-play')
          .trim() ||
          'rgba(0,0,0,0.3)';

      const render = (color, clip) => {

        g.save();

        if(clip){

          g.beginPath();

          g.rect(0,0,cut,h);

          g.clip();
        }

        g.fillStyle = color;

        for(let i=0;i<peaks.length;i++){

          const amp = Math.max(
            1,
            (peaks[i] / 255) *
            (h * 0.9) *
            WAVE_GAIN
          );

          g.fillRect(
            i * step + (step - bw)/2,
            mid - amp,
            bw,
            amp * 2
          );
        }

        g.restore();
      };

      render(base, false);
      render(play, true);
    };

    const resetWave = (t) => {

      if(!t) return;

      drawWave(t, 0);

      const total =
        t._totalSec || 0;

      setTime(t, 0, total);
    };

    /* =========================
       PEAKS
    ========================= */

    const ensurePeaks = async (t) => {

  const src = t.dataset.src;

  if(!src){
    markMissing(t);
    throw new Error("missing src");
  }

  if(peaksMem.has(src)){
    return peaksMem.get(src);
  }

  /* DRG FIX: 初回連打・再生切替で同じ波形解析が多重に走るのを防ぐ */
  if(peaksLoading.has(src)){
    return peaksLoading.get(src);
  }

  const job = (async () => {

    try {

      const res = await fetch(src);

      if(!res.ok){
        throw new Error("wave fetch failed");
      }

      const buf =
        await res.arrayBuffer();

      const AC =
        window.AudioContext ||
        window.webkitAudioContext;

      const ctx = new AC();

      const ab =
        await ctx.decodeAudioData(buf);

      const peaks = extract(ab);

      peaksMem.set(src, peaks);

      ctx.close?.();

      return peaks;

    } catch(err){

      markMissing(t);

      throw err;

    } finally {

      peaksLoading.delete(src);
    }
  })();

  peaksLoading.set(src, job);

  return job;
};

    /* =========================
       PROGRESS
    ========================= */

    const startProgress = () => {

      stopProgress();

      timer = setInterval(() => {

        if(
          !currentTrack ||
          !audio.duration ||
          dragging
        ) return;

        const ratio =
          audio.currentTime /
          audio.duration;

        drawWave(
  visualTrack || currentTrack,
  ratio,
  currentTrack
);

setTime(
  visualTrack || currentTrack,
  audio.currentTime,
  audio.duration
);

      }, 120);
    };

    /* =========================
       PLAY
    ========================= */

    const playTrack = async (
  t,
  ratio = 0
) => {

  if(!t.classList.contains('drg-ready')){
    return;
  }

      if(isMissing(t)) return;

      try {

        if(
          currentTrack &&
          currentTrack !== t
        ){

          audio.pause();

          resetWave(currentTrack);

          if(getVisualTrack(currentTrack) !== getVisualTrack(t)){
  clearStates();
}

}

        currentTrack = t;

        visualTrack = getVisualTrack(t);

        setCopyType(
  visualTrack,
  t
);

setActiveClip(
  visualTrack,
  t
);

        const groupForVisual =
  findGroupByParent(visualTrack);

const totalClips =
  groupForVisual
    ? groupForVisual.children.length + 1
    : 1;

const currentClip =
  t === visualTrack
    ? 1
    : groupForVisual.children.indexOf(t) + 2;

setClipPos(
  visualTrack,
  currentClip,
  totalClips
);

        applyLoadingState(visualTrack || t);
        refreshMarquee(visualTrack || t);

audio.pause();

audio.src = t.dataset.src;

        audio.onloadedmetadata =
          async () => {

          if(audio.duration){

            audio.currentTime =
              ratio * audio.duration;
          }

          drawWave(
  visualTrack || t,
  ratio,
  t
);

setTime(
  visualTrack || t,
  audio.currentTime,
  audio.duration
);

          try {

            await audio.play();

applyPlayingState(visualTrack || t);
if(currentTrack !== t) return;

requestAnimationFrame(() => {

  t.scrollIntoView({
    block:'nearest'
  });

});

startProgress();


          } catch(err){

            applyPausedState(t);
          }
        };

        audio.onerror = () => {

          markMissing(t);

          const idx =
            tracks.indexOf(t);

          const next = tracks
            .slice(idx + 1)
            .find(x => !isMissing(x));

          if(next){
            playTrack(next, 0);
          }
        };

        audio.load();

      } catch(err){}
    };

    const pauseTrack = (t) => {

      audio.pause();

      applyPausedState(t);

      stopProgress();
    };

    /* =========================
       SEEK
    ========================= */

    const previewSeek = (t, x) => {

  if(isMissing(t)) return;

  const ratio =
    ratioAt(t, x);

  const target =
    currentTrack || t;

  const visual =
    currentTrack ? getVisualTrack(currentTrack) : t;

  const total =
    audio.duration ||
    target._totalSec ||
    t._totalSec ||
    0;

  const preview =
    total * ratio;

  drawWave(
    visual,
    ratio,
    target
  );

  setTime(
    visual,
    preview,
    total
  );
};

    const finishSeek = async (
  t,
  x
) => {

  if(isMissing(t)) return;

  const ratio =
    ratioAt(t, x);

  const target =
    currentTrack || t;

  const visual =
    getVisualTrack(target);

  if(
    !currentTrack ||
    getVisualTrack(currentTrack) !== t
  ){
    playTrack(t, ratio);
    return;
  }

  if(audio.duration){

    audio.currentTime =
      ratio * audio.duration;

    drawWave(visual, ratio, target);

    setTime(
      visual,
      audio.currentTime,
      audio.duration
    );
  }

  if(wasPlayingBeforeDrag){

    try {

      await audio.play();

      applyPlayingState(visual);

      startProgress();

    } catch(err){}

  } else {

    pauseTrack(visual);
  }
};

    /* =========================
       TAP
    ========================= */

    const handleTap = (t) => {

  if(isMissing(t)) return;

  if(!t.classList.contains('drg-ready')){
    return;
  }

  const group = findGroupByParent(t);

  const visual =
  currentTrack ? getVisualTrack(currentTrack) : null;

if(
  visual === t &&
  currentTrack !== t
){
  if(audio.paused){
  audio.play().then(() => {
    applyPlayingState(t);

    if(currentTrack){
      setActiveClip(
        getVisualTrack(currentTrack),
        currentTrack
      );
    }

    startProgress();
  });
} else {
    pauseTrack(t);
  }

  return;
}

  if(group && group.children.length){

  const alreadyOpen =
    t.classList.contains("drg-group-open");

  openGroup(group);

  if(
    !currentTrack ||
    currentTrack !== t
  ){


    if(currentTrack !== t){
  playTrack(t, 0);
}

    return;
  }
}

  if(
    !currentTrack ||
    currentTrack !== t
  ){

    closeGroups();
    playTrack(t, 0);

    return;
  }

  if(audio.paused){

    audio.play().then(() => {

      applyPlayingState(t);

      startProgress();
    });

  } else {

    pauseTrack(t);
  }
};

    const handleDoubleClick = (
      t,
      x
    ) => {

      finishSeek(t, x);
    };

    /* =========================
       POINTER
    ========================= */

    tracks.forEach(t => {

      refreshMarquee(t);

      t.addEventListener(
        'pointerdown',
        e => {

        if(isMissing(t)) return;

        dragTrack = t;

        startX = e.clientX;
        startY = e.clientY;

        movedX = 0;
        movedY = 0;

        dragging = false;

        wasPlayingBeforeDrag =
  (
    currentTrack &&
    getVisualTrack(currentTrack) === t &&
    !audio.paused
  );

        t.setPointerCapture(
          e.pointerId
        );
      });

      t.addEventListener(
        'pointermove',
        e => {

        if(!dragTrack) return;

        movedX =
          Math.abs(
            e.clientX - startX
          );

        movedY =
          Math.abs(
            e.clientY - startY
          );

        if(
  movedX > SEEK_THRESHOLD &&
  movedX > movedY * SEEK_DOMINANCE
){

          dragging = true;

          e.preventDefault();

          if(!audio.paused){
            audio.pause();
          }

          previewSeek(
            dragTrack,
            e.clientX
          );
        }
      });

      t.addEventListener(
        'pointerup',
        e => {

        if(!dragTrack) return;

        if(dragging){

  finishSeek(
    dragTrack,
    e.clientX
  );

} else if(
  movedX > TAP_CANCEL_THRESHOLD ||
  movedY > TAP_CANCEL_THRESHOLD
){

} else {

          const now = Date.now();

          if(
            lastClickTrack === t &&
            now - lastClickTime <
            DOUBLE_CLICK_MS
          ){

            clearTimeout(clickTimer);

            handleDoubleClick(
              t,
              e.clientX
            );

            lastClickTrack = null;
            lastClickTime = 0;

          } else {

            lastClickTrack = t;

            lastClickTime = now;

            clickTimer = setTimeout(
              () => {

              handleTap(t);

            }, DOUBLE_CLICK_MS);
          }
        }

        dragTrack.releasePointerCapture(
          e.pointerId
        );

        dragTrack = null;

        dragging = false;
      });
    });

    /* =========================
       ENDED
    ========================= */

    audio.addEventListener(
  'ended',
  () => {

  if(!currentTrack) return;

  const idx =
    tracks.indexOf(currentTrack);

  const visual =
  getVisualTrack(currentTrack);

resetWave(visual);

clearStates();

  const next = (() => {

    for(
      let i=1;
      i<=tracks.length;
      i++
    ){

      const n =
        tracks[
          (idx + i) %
          tracks.length
        ];

      if(!isMissing(n)){
        return n;
      }
    }

    return null;

  })();

  if(idx === tracks.length - 1){

    root
      .querySelector('.drg-list')
      ?.scrollTo({
        top:0,
        behavior:'smooth'
      });
  }

  if(next){

  const nextVisual =
    getVisualTrack(next);

  if(nextVisual !== visual){
    closeGroups();

    const nextGroup =
      findGroupByParent(nextVisual);

    if(nextGroup && nextGroup.children.length){
      openGroup(nextGroup);
    }
  }

  playTrack(next, 0);
}

});

/* =========================
   CLOSE ON OUTSIDE TAP
========================= */

let outsideTapStartX = 0;
let outsideTapStartY = 0;

document.addEventListener(
  'pointerdown',
  e => {

    outsideTapStartX = e.clientX;
    outsideTapStartY = e.clientY;
  }
);

document.addEventListener(
  'pointerup',
  e => {

    const dx = Math.abs(
      e.clientX - outsideTapStartX
    );

    const dy = Math.abs(
      e.clientY - outsideTapStartY
    );

    if(
      dx > TAP_THRESHOLD ||
      dy > TAP_THRESHOLD
    ) return;

    if(root.contains(e.target)) return;

    if(
      currentTrack &&
      audio.paused
    ){

      clearStates();
      closeGroups();

      currentTrack = null;
      visualTrack = null;
    }
  }
);

    /* =========================
       INIT
    ========================= */

    (async () => {

      /* DRG READY */

tracks.forEach(t => {

  t.classList.add('drg-not-ready');
  const titleText =
  t.querySelector('.drg-player-title-text');

if(titleText){

  titleText.dataset.originalTitle =
    titleText.textContent;

  titleText.textContent =
    'Loading...';
}

  ensurePeaks(t)
  .then(() => {

    setTimeout(() => {

      t.classList.add('drg-ready');
      t.classList.remove('drg-not-ready');

      const titleText =
        t.querySelector('.drg-player-title-text');

      if(
        titleText &&
        titleText.dataset.originalTitle
      ){
        titleText.textContent =
          titleText.dataset.originalTitle;
      }

      if(t._totalSec){
        setTime(t, 0, t._totalSec);
      }

    }, 600);

  })
    .catch(() => {

      t.classList.remove('drg-ready');
      t.classList.add('drg-not-ready');

    });

});

      for(const t of tracks){

        refreshMarquee(t);

        try {

          const a = new Audio();

          a.preload = 'metadata';

          a.src = t.dataset.src;

          await new Promise(res => {

            a.onloadedmetadata = () => {

              t._totalSec =
                a.duration || 0;

              setTime(
                t,
                0,
                t._totalSec
              );

              drawWave(t, 0);

              res();
            };

            a.onerror = () => {

              markMissing(t);

              res();
            };
          });

        } catch(err){

          markMissing(t);
        }
      }

            window.addEventListener(
        'resize',
        () => {
          tracks.forEach(
            refreshMarquee
          );
        }
      );

      root.classList.add('drg-player-ready');

window.addEventListener(
  'pageshow',
  () => {

          audio.pause();

          stopProgress();

          clearStates();
          closeGroups();

          currentTrack = null;
          visualTrack = null;

        }
      );

    })();

  });

})();